/* Makes the Judge.me star badge on the product page jump down to the review
   widget.

   Judge.me injects the badge markup after the page has loaded, so the click is
   handled by delegation on the document instead of bound to the element, and a
   MutationObserver stamps the accessibility attributes once the badge appears.
   Scroll offset for the sticky header comes from scroll-margin-top in
   judgeme-custom.css. */
(function () {
  const WIDGET_ID = 'judgeme_product_reviews';
  const BADGE_SELECTOR = '.jdgm-preview-badge .jdgm-prev-badge';

  function scrollToWidget(event) {
    const widget = document.getElementById(WIDGET_ID);
    if (!widget) return;

    event.preventDefault();
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Capture phase, not bubble: Judge.me binds its own handler to the badge
  // (it carries a jdgm-preview-badge--with-link class) and stops propagation,
  // so a bubble-phase listener on the document never runs.
  document.addEventListener('click', function (event) {
    if (!event.target.closest(BADGE_SELECTOR)) return;
    scrollToWidget(event);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.closest(BADGE_SELECTOR)) return;
    scrollToWidget(event);
  }, true);

  // Only worth observing on a page that actually has a review widget to reach.
  function markBadges() {
    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      if (badge.dataset.scrollLinked) return;
      badge.dataset.scrollLinked = 'true';
      badge.setAttribute('role', 'link');
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('aria-label', 'Read customer reviews');
    });
  }

  function init() {
    if (!document.getElementById(WIDGET_ID)) return;
    markBadges();
    new MutationObserver(markBadges).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
